require('./src/assets/styles/_index.scss');
exports.onClientEntry = () => {};
